<div fxLayout="row" fxLayoutAlign="space-between center" class="p-20">
  <button mat-raised-button (click)="regresar()">
    {{'EDITOR.ELEMENTOS.BOTONES.REGRESAR' | translate}}
    <mat-icon class="ml-20">arrow_back</mat-icon>
  </button>
  <button mat-raised-button (click)="abreModalConfig()" color="accent">
    {{'EDITOR.CONFIGADICIONAL.TITULO' | translate}}
    <mat-icon class="ml-20">settings</mat-icon>
  </button>
</div>
<ng-container *ngIf="cargando">
  <div fxLayout="column" class="p-20" fxLayoutAlign="space-between center" >
    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
    <h1>{{'EDITOR.CARGANDO'|translate}}</h1>
  </div>
</ng-container>
<mat-tab-group *ngIf="!cargando" (selectedTabChange)="cambioIdioma($event)">
  <mat-tab [label]="'NOMBREIDIOMAS.'+idioma.nombreIdioma | translate" *ngFor="let idioma of idiomas">
    <mat-horizontal-stepper labelPosition="bottom" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
      <mat-step *ngFor="let pagina of paginas; let idxPag = index;">
        <ng-template matStepLabel>{{'EDITOR.PANTALLAS.'+pagina.nombre+'.TITULO' | translate}}</ng-template>
        <h2>{{'EDITOR.PANTALLAS.'+pagina.nombre+'.TITULO' | translate}}</h2>
        <div class="mb-10" fxLayout="row" fxLayoutAlign="space-between start" *ngFor="let paso of pagina.pasos; let idxPaso = index;">
          <button mat-icon-button class="mr-20" [ngClass]="{'botEdit':paso.status == 2, 'botMod':paso.status == 1, 'botPend':paso.status == 0}">
            <ng-container [ngSwitch]="paso.status">
              <mat-icon *ngSwitchCase="0" matTooltip="{{'EDITOR.ELEMENTOS.TOOLTIPS.ORIGINAL' | translate}}">more_horiz</mat-icon>
              <mat-icon *ngSwitchCase="1" matTooltip="{{'EDITOR.ELEMENTOS.TOOLTIPS.MODIFICADO' | translate}}">edit</mat-icon>
              <mat-icon *ngSwitchCase="2" matTooltip="{{'EDITOR.ELEMENTOS.TOOLTIPS.COMPLETO' | translate}}">done</mat-icon>
            </ng-container>
          </button>
          <mat-expansion-panel fxFlex>
            <mat-expansion-panel-header class="cabeceraSeccion" [ngClass]="{'stepDone':paso.status == 2, 'botMod':paso.status == 1, 'accent-50':paso.status == 0}">
              <mat-panel-title>
                {{'EDITOR.PANTALLAS.' + pagina.nombre + '.PASOS.' + paso.nombre + '.TITULO' | translate}}
              </mat-panel-title>
              <div class="accionesPregunta">
                <button mat-raised-button color="primary" (click)="$event.stopPropagation();verAyudaElemento(idxPag,idxPaso)">
                  {{'EDITOR.ELEMENTOS.BOTONES.ELEMENTOS' | translate}}
                  <mat-icon class="ml-20">info</mat-icon>
                </button>
              </div>
            </mat-expansion-panel-header>
            <div fxLayout="row wrap" fxLayoutAlign="space-between start">
              <div class="mt-10 mb-10" fxLayout="row" fxLayoutAlign="start center" fxFlex="100">
                <div class="catColor mr-20"></div>
                <p class="m-0"><em>{{'EDITOR.ELEMENTOS.COLORES.ORIGINAL' | translate}}</em></p>
                <div class="catColor stepDone ml-40 mr-20"></div>
                <p class="m-0"><em>{{'EDITOR.ELEMENTOS.COLORES.MODIFICADO' | translate}}</em></p>
              </div>
              <ng-container *ngFor="let elemento of paso.elementos; let idxElm = index; last as last;">

                <ng-container [ngSwitch]="elemento.tipo">

                  <ng-container *ngSwitchCase="'imagen'">
                    <div fxFlex="48" fxLayout="column" fxLayoutAlign="start stretch" class="mb-20">
                      <div fxLayout="row" fxLayoutAlign="start center" class="infoElemento" [ngClass]="{'infoMod':datasetsModif[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value == true}">
                        <div class="circNum" [ngClass]="{'circModif':datasetsModif[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value == true}">{{(idxElm+1)}}</div>
                        <p class="m-0"><em>{{'EDITOR.PANTALLAS.' + pagina.nombre + '.PASOS.' + paso.nombre + '.ELEMENTOS.' + elemento.id | translate}}</em></p>
                      </div>
                      <input id="imagen{{idioma.nombreIdioma}}-{{idxPag}}-{{idxPaso}}-{{idxElm}}" type="file" (change)="openCropperDialog($event, idxPag, pagina.id, paso.id, elemento.id, idioma.nombreIdioma)" accept="image/*" hidden>
                      <div fxLayout="row" fxLayoutAlign="center center">
                        <mat-card class="mat-elevation-z4">
                          <mat-card-header>
                            <mat-card-subtitle *ngIf="!datasets[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value">{{'EDITOR.ELEMENTOS.ETIQUETAS.IMAGEN.NOHAY' | translate}}</mat-card-subtitle>
                            <mat-card-subtitle *ngIf="datasets[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value">{{'EDITOR.ELEMENTOS.ETIQUETAS.IMAGEN.ACTUAL' | translate}}</mat-card-subtitle>
                          </mat-card-header>
                          <mat-card-content>
                            <img [src]="datasets[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value">
                          </mat-card-content>
                          <mat-card-actions>
                            <button mat-raised-button (click)="cambiarImagen(idxPag,idxPaso,idxElm,idioma.nombreIdioma)">{{'EDITOR.ELEMENTOS.BOTONES.IMAGEN' | translate}}</button>
                          </mat-card-actions>
                        </mat-card>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'texto'">
                    <div fxFlex="48" fxLayout="column" fxLayoutAlign="start stretch" class="mb-20">
                      <div fxLayout="row" fxLayoutAlign="start center" class="infoElemento" [ngClass]="{'infoMod':datasetsModif[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value == true}">
                        <div class="circNum" [ngClass]="{'circModif':datasetsModif[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value == true}">{{(idxElm+1)}}</div>
                        <p class="m-0"><em>{{'EDITOR.PANTALLAS.' + pagina.nombre + '.PASOS.' + paso.nombre + '.ELEMENTOS.' + elemento.id | translate}}</em></p>
                      </div>
                      <mat-form-field appearance="outline" fxFlex>
                        <mat-label>{{'EDITOR.ELEMENTOS.ETIQUETAS.TEXTO.INGRESAR' | translate}}</mat-label>
                        <input matInput [(ngModel)]="datasets[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value" (blur)="modificarDatoJson(idxPag, pagina.id, paso.id, elemento.id, idioma.nombreIdioma)">
                      </mat-form-field>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'check'">
                    <div fxFlex="48" fxLayout="column" fxLayoutAlign="start stretch" class="mb-20">
                      <div fxLayout="row" fxLayoutAlign="start center" class="infoElemento" [ngClass]="{'infoMod':datasetsModif[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value == true}">
                        <div class="circNum" [ngClass]="{'circModif':datasetsModif[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value == true}">{{(idxElm+1)}}</div>
                        <p class="m-0"><em>{{'EDITOR.PANTALLAS.' + pagina.nombre + '.PASOS.' + paso.nombre + '.ELEMENTOS.' + elemento.id | translate}}</em></p>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="center center">
                        <p>{{'EDITOR.ELEMENTOS.BOTONES.DESACTIVAR' | translate}}</p>
                        <mat-slide-toggle [(ngModel)]="datasets[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value" class="ml-20 mr-20" (change)="modificarDatoJson(idxPag, pagina.id, paso.id, elemento.id, idioma.nombreIdioma)"></mat-slide-toggle>
                        <p>{{'EDITOR.ELEMENTOS.BOTONES.ACTIVAR' | translate}}</p>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'editorHTML'">
                    <div fxFlex="48" fxLayout="column" fxLayoutAlign="start stretch" class="mb-20">
                      <div fxLayout="row" fxLayoutAlign="start center" class="infoElemento" [ngClass]="{'infoMod':datasetsModif[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value == true}">
                        <div class="circNum" [ngClass]="{'circModif':datasetsModif[idxPag].controls[idioma.nombreIdioma + '_' + pagina.id + '_' + paso.id + '_' + elemento.id].value == true}">{{(idxElm+1)}}</div>
                        <p class="m-0"><em>{{'EDITOR.PANTALLAS.' + pagina.nombre + '.PASOS.' + paso.nombre + '.ELEMENTOS.' + elemento.id | translate}}</em></p>
                      </div>
                      <button mat-raised-button color="primary" (click)="abreModalEditor(idxPag, pagina.id, paso.id, elemento.id, idioma.nombreIdioma, 'EDITOR.PANTALLAS.' + pagina.nombre + '.PASOS.' + paso.nombre + '.ELEMENTOS.' + elemento.id)">
                        {{'EDITOR.ELEMENTOS.BOTONES.EDITOR' | translate}}
                        <mat-icon class="ml-20">edit</mat-icon>
                      </button>
                    </div>
                  </ng-container>

                </ng-container>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-tab>
</mat-tab-group>
<div class="guardandoTemplate" *ngIf="guardandoTemplate" fxLayout="row" fxLayoutAlign="start center">
  <em class="mr-20">{{'EDITOR.GUARDANDO'|translate}}</em>
  <mat-spinner diameter="25"></mat-spinner>
</div>
